// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mainmenu-header-bar {\n  border-bottom: solid 1px;\n  color: #00368f;\n  font-size: 1.5em;\n  display: block;\n  height: 50px;\n  margin: 1% auto 0% auto;\n  min-width: 30%;\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  max-width: 100%;\n  text-align: center;\n  font-size: clamp(20px, 1.5vw, 30px);\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
